export const goToMailCommand = "hTb";
export const goToCalendarCommand = "iTb";
export const goToPeopleCommand = "jTb";
export const goToTasksCommand = "kTb";
export const goToToDoCommand = "lTb";
export const goToDevToolsCommand = "mTb";
export const goToEdgeTracingToolsCommand = "nTb";
export default {goToMailCommand,goToCalendarCommand,goToPeopleCommand,goToTasksCommand,goToToDoCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand};